import { useState } from 'react';
import IPDService from '../services/ipdService';
import { toast } from 'react-toastify';

const ipdService = new IPDService();

export const useAddTimelineEntry = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const addEntry = async (data) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Hook received data:', data); // Debug log
            const response = await ipdService.addTimelineEntry(data.ipdVisitId, {
                eventType: data.eventType,
                notes: data.notes,
                ...(data.bedId && { bedId: data.bedId }),
                ...(data.doctorIds && { doctorIds: data.doctorIds })
            });
            return response;
        } catch (error) {
            console.error('Add timeline error in hook:', error);
            const errorMessage = error.response?.data?.message?.[0] || error.message || 'Failed to add timeline entry';
            setError(errorMessage);
            toast.error(errorMessage);
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        addEntry,
        loading,
        error
    };
}; 